import { Page } from './pages';

import { PATH } from '../../../constants';

export default {
  component: Page,
  name: 'Schedule',
  path: PATH.PROFILES_SCHEDULE,
  exact: false,
  isPrivate: true,
  roles: []
};
